import * as React from "react";
const SvgFiRrHandDots = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-dots_svg__a)">
      <path
        fill="#062147"
        d="M22.943 3.714a3 3 0 0 0-2.439-.674 2.8 2.8 0 0 0-.618.184A2.995 2.995 0 0 0 17 1c-.537 0-1.034.153-1.47.401A3 3 0 0 0 13 0a2.996 2.996 0 0 0-2.886 2.225 2.8 2.8 0 0 0-.618-.185 3 3 0 0 0-2.439.674A3 3 0 0 0 6 5v8.699l-.955-.891A2.999 2.999 0 0 0 .94 17.182l4.457 4.297A8.96 8.96 0 0 0 11.643 24H19c2.757 0 5-2.243 5-5V6c0-.881-.385-1.714-1.057-2.286M22 19c0 1.654-1.346 3-3 3h-7.357a6.97 6.97 0 0 1-4.858-1.96l-4.468-4.307a1.005 1.005 0 0 1-.047-1.417 1 1 0 0 1 .694-.315c.292.003.521.087.715.269l2.638 2.462A1.001 1.001 0 0 0 8 16.001V5c0-.294.13-.572.353-.762.228-.193.52-.272.822-.224.463.076.825.556.825 1.093V10a1 1 0 1 0 2 0V3a1.001 1.001 0 0 1 2 0v7a1 1 0 1 0 2 0V4a1.001 1.001 0 0 1 2 0v6a1 1 0 1 0 2 0V6.107c0-.538.362-1.018.824-1.093.302-.048.596.031.823.224.224.19.353.468.353.762zm-7-4.5a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001m5 0a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001m-2 4a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001m-5 0a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-dots_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandDots;
